// Build identity, stamped by the `define` block in vite.config.js.
// The typeof guards keep vitest (which runs on vitest.config.js, no
// defines) and any other non-Vite consumer from throwing on the bare
// identifiers.
/* global __APP_VERSION__, __APP_COMMIT__ */
export const APP_VERSION =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";
export const APP_COMMIT =
  typeof __APP_COMMIT__ !== "undefined" ? __APP_COMMIT__ : "local";
